import { Col, Input, Row } from 'antd';
import { FC } from 'react';
import { CancelIcon, SearchSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { SearchAndFilterProps } from './types';

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
	const {
		performSearchHandler,
		searchValue,
		title,
		isSearchCancel,
		setSearch,
		setIsSearchCancel,
	} = props;

	return (
		<div className={styles['search-filter']}>
			<div className={styles['search-filter__wrapper']}>
				<Row justify="space-between">
					<Col>
						<div className={styles['search-filter__wrapper--title']}>{title}</div>
					</Col>
					<Col>
						<Input
							className={styles['search-filter__search']}
							placeholder="Search by category name"
							prefix={<SearchSvg />}
							onChange={performSearchHandler}
							value={searchValue}
							size="large"
							suffix={
								isSearchCancel && setSearch && setIsSearchCancel ? (
									<span
										style={{ display: 'flex', cursor: 'pointer' }}
										onClick={() => {
											setSearch('');
											setIsSearchCancel(false);
										}}
									>
										<CancelIcon />
									</span>
								) : null
							}
						/>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default SearchAndFilter;
